import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/about.css';
import spiderLogo from '../../assets/images/logo2.png';

const About = () => {
    return (
        <div className="about-container">
            <div className="about-content">
                <div className="logo-container">
                    <h1 className="game-title">About</h1>
                    <div className="spider-logo">
                        <img src={spiderLogo} alt="Spider Logo" />
                    </div>
                </div>

                <div className="about-text">
                    <div className="about-section">
                        <h2>Spider Solitaire</h2>
                        <p>
                            This classic card game has been reimagined for the modern web. 
                            Test your strategy and patience as you arrange cards in descending order 
                            to clear the table.
                        </p>
                    </div>

                    {/* <div className="about-section">
                        <h3>Game Features</h3>
                        <ul>
                            <li>Beautiful responsive design</li>
                            <li>Smooth animations and effects</li>
                            <li>High score tracking</li>
                            <li>Multiple difficulty levels</li>
                        </ul>
                    </div> */}

                    <div className="about-section credits">
                        <h3>Credits</h3>
                        <p>
                            This game is made by <strong>HONEST</strong>
                        </p>
                        <p className="copyright">
                            © 2025 HONEST. All rights reserved.
                        </p>
                    </div>
                </div>

                <div className="menu-buttons">
                    <Link to="/">
                        <button className="menu-btn back-btn">
                            Back to Home
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default About; 